import { motion } from "framer-motion";
import { useEffect, useState } from "react";

// Animated network/dashboard SVG used in hero & visual sections.
export default function NetworkVisual({ className = "" }) {
  const [bars, setBars] = useState(Array(24).fill(20));

  useEffect(() => {
    const id = setInterval(() => {
      setBars((b) => b.map(() => 10 + Math.random() * 80));
    }, 800);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="network-visual"
      className={`relative border border-white/10 bg-[#0A0A0D] overflow-hidden ${className}`}
    >
      <div className="absolute inset-0 bg-grid opacity-50" />
      <div className="scan-line" />

      {/* Top status bar */}
      <div className="relative z-10 flex items-center justify-between px-4 py-2 border-b border-white/10 bg-black/40">
        <div className="flex items-center gap-2 font-mono text-[10px] tracking-widest text-[#00F0FF]">
          <span className="w-1.5 h-1.5 bg-[#39FF14] pulse-dot" />
          LIVE FEED
        </div>
        <div className="font-mono text-[10px] text-[#8B93A5] hidden sm:block">
          NODE-04 / 192.168.10.4 / TLS-1.3
        </div>
      </div>

      <div className="grid grid-cols-12 gap-3 p-4 relative z-10">
        {/* Threat graph */}
        <div className="col-span-12 md:col-span-7 border border-white/10 p-3 bg-black/30">
          <div className="flex justify-between font-mono text-[10px] text-[#8B93A5] mb-2">
            <span>THREAT ACTIVITY</span>
            <span className="text-[#39FF14]">+12.4%</span>
          </div>
          <div className="flex items-end gap-1 h-28">
            {bars.map((h, i) => (
              <motion.div
                key={i}
                animate={{ height: `${h}%` }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className={`flex-1 ${
                  h > 70 ? "bg-[#39FF14]" : h > 40 ? "bg-[#00F0FF]" : "bg-white/30"
                }`}
              />
            ))}
          </div>
        </div>

        {/* Mini stats */}
        <div className="col-span-12 md:col-span-5 grid grid-cols-2 gap-3">
          {[
            { l: "Blocked", v: "1.2K", c: "#39FF14" },
            { l: "Latency", v: "12ms", c: "#00F0FF" },
            { l: "Active", v: "248", c: "#fff" },
            { l: "CVE", v: "0 CRIT", c: "#39FF14" },
          ].map((s) => (
            <div key={s.l} className="border border-white/10 bg-black/30 p-3">
              <div className="font-mono text-[10px] text-[#8B93A5] uppercase">{s.l}</div>
              <div className="font-display font-bold text-lg mt-1" style={{ color: s.c }}>
                {s.v}
              </div>
            </div>
          ))}
        </div>

        {/* Log feed */}
        <div className="col-span-12 border border-white/10 bg-black/30 p-3 font-mono text-[10px] text-[#8B93A5] space-y-1">
          {[
            { t: "00:42:11", m: "Port scan blocked from 45.92.x.x", c: "#39FF14" },
            { t: "00:42:08", m: "Anomalous outbound DNS — flagged", c: "#00F0FF" },
            { t: "00:42:01", m: "Patch applied: CVE-2025-30461", c: "#fff" },
          ].map((l) => (
            <div key={l.t} className="flex gap-3">
              <span>{l.t}</span>
              <span style={{ color: l.c }}>●</span>
              <span className="truncate">{l.m}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
